// Returns a var() reference rather than the resolved value, so styles built at
// module load still follow the light/dark theme when it changes.
export const getAppColors = (color: string) => `var(${color})`

export const CHART_COLORS = [
  getAppColors('--color-error'),
  getAppColors('--color-warning'),
  getAppColors('--color-success'),
]

export const CHART_COLOR_PLACEHOLDER = getAppColors('--color-gray-1')

export const CHART_COLOR_BLUE = getAppColors('--color-primary')
